import React from 'react'
import { CardContext } from './types'

export default React.createContext<CardContext>({
  id: 0
})